<template>
  <div class="tw-p-4 legacy-lg:tw-p-6 tw-grid tw-gap-10">
      <BeatTapeHeader class="tw-relative tw-z-10" :beat-tape="beatTape" />
      <div>
        <beat-row-header></beat-row-header>
        <row-beat-tape-container v-for="item in beatTapePlaylist" :beat-tape-item="item" :key="item.id" :show-price="true" :show-download="true" display="list" :image-size="100"></row-beat-tape-container>
      </div>
  </div>
</template>
<script>
import BeatTapeHeader from "./views/beat-tape-header.vue";
import RowBeatTapeContainer from '../rowbeattapecontainer.vue'
import BeatRowHeader from './../beatrowheader.vue'
import BeatTapes from "../../models/beat-tapes";
import Beat from "../../models/beat";

export default {
  components: {
      BeatTapeHeader,RowBeatTapeContainer,BeatRowHeader
  },
  props: {
      beatTapePlaylist: {
         type: Array
      },
      beatTape: {
          type: BeatTapes,
          required: true
      },
      pageId: {
        type: String,
      }
  },
  computed: {

    config() {
      return this.$store.state.currentConfig
    },
    beatTapeItems() {
      return Beat.makeArray(this.beatTape.items.map(item => ( {...item.music_item, license: item.license})))
    }
  }
};
</script>
